import axios from "axios";
import * as PATH from "../helpers/APIURL";

export default class ReserveService {

    static getReserveList = (restaurantId, params) => {
        return axios.get(`${PATH.GET_RESERVE_LIST}/${restaurantId}`, {params});
    }

    static getReservedFloorTables = (restaurantId, reservedId) => {
        return axios.get(`${PATH.GET_RESERVED_FLOOR_TABLES_RESERVED_ID}/${reservedId}/${restaurantId}`);
    }

    static getReserveById = (id, restaurantId) => {
        return axios.get(`${PATH.GET_RESERVE_BY_ID}/${id}/${restaurantId}`);
    }

    static getReserveStatesByReserveId = (id, restaurantId) => {
        return axios.get(`${PATH.GET_RESERVE_STATES_BY_RESERVE_ID}/${id}/${restaurantId}`);
    }

    static editReserve = (data, id, restaurantId) => {
        return axios.put(`${PATH.UPDATE_RESERVE}/${id}/${restaurantId}`, data);
    }

    static editReserveStates = (params, id, restaurantId) => {
        return axios.put(`${PATH.UPDATE_RESERVE_STATUS}/${id}/${restaurantId}`, null, {params}
        );
    }

    static createReserve = (data, id) => {
        return axios.post(`${PATH.CREATE_RESERVE}/${id}`, data);
    }

    static getReserveCSVData = (id, params) => axios.get(`${PATH.GET_RESERVE_CSV_DATA}/${id}`, {params});

}
